import Layout from '@/components/layout/Layout';
import SuccessContent from '@/components/tax-refund/result/Success/SuccessContent';

const ResultSuccessPage = () => {
  return (
    <Layout>
      <SuccessContent />
    </Layout>
  );
};

export default ResultSuccessPage;
